// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1hkcO","actionsCol":"EnrolledClinics_actionsCol__3KAEO"};